getDunderProto